import { Link, NavLink } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { isCvOwner } from '../auth/RequireAuth';

const NavBar = ({ goToSection }: { goToSection: (id: string) => void }) => {
    const { user } = useAuth();
    console.log('user', user);
    return (
        <header className="site-header p-5">
            <a className="logo-link" onClick={() => goToSection('home')} style={{ cursor: 'pointer' }}>
                <img src="/altwhite.png" alt="Forget-IT" className="logo-img" />
            </a>
            <nav>
                <ul>
                    <li><a onClick={() => goToSection('home')}>Home</a></li>
                    <li><a onClick={() => goToSection('services')}>Services</a></li>
                    <li><NavLink to="/hosting">Hosting</NavLink></li>
                    <li><a onClick={() => goToSection('portfolio')}>Portfolio</a></li>
                    <li><a onClick={() => goToSection('contact')}>Contact</a></li>
                </ul>
            </nav>
            <nav className="nav-auth">
                <ul>
                    {isCvOwner(user) && <li><NavLink to="/cv">CV</NavLink></li>}
                    {user?.role === 'admin' && <li><NavLink to="/admin">Admin</NavLink></li>}
                    {user ? (
                        <li><NavLink to="/account">My account</NavLink></li>
                    ) : (
                        <>
                            <li><NavLink to="/login">Log in</NavLink></li>
                            <li><Link to="/register" className="nav-cta">Sign up</Link></li>
                        </>
                    )}
                </ul>
            </nav>
        </header>
    );
};

export default NavBar;
